/**
 * Replaces legacy `:ft_picklist` notation with `:ftListValue`.
 * Used to normalize old path strings in form data actions.
 * (former updateOldValue in processPortalRules, extracted here)
 */
export const normalizeKeyPath = (value) => String(value).replace(':ft_picklist', ':ftListValue')
